export default __webpack_public_path__ + "static/media/renault.5d81bdc5.png";